import { render, staticRenderFns } from "./PageRegister.vue?vue&type=template&id=735a9f3a&scoped=true&"
import script from "./PageRegister.vue?vue&type=script&lang=js&"
export * from "./PageRegister.vue?vue&type=script&lang=js&"
import style0 from "./PageRegister.vue?vue&type=style&index=0&id=735a9f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a9f3a",
  null
  
)

export default component.exports